import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DialogShellComponent, OutlinedButtonComponent } from '@custom-components';

/**
 * Read-only dialog showing the partnership terms and conditions. The body is placeholder
 * text held in the `partnerships.terms.body` translation and will be replaced with the
 * final agreement later.
 */
@Component({
  selector: 'xemex-partnership-terms-dialog',
  imports: [MatDialogModule, TranslateModule, DialogShellComponent, OutlinedButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './partnership-terms-dialog.component.html',
})
export class PartnershipTermsDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<PartnershipTermsDialogComponent>);

  onClose(): void {
    this.dialogRef.close();
  }
}
